import { Field, TextInput } from '@carboledger/ui';

/**
 * Props:
 *   name         form field name
 *   label        the field label
 *   placeholder  the empty-input hint
 *   type         input type; `date` for a validity box
 *   rules        format rules for this field
 *   required     defaults to false
 *   disabled     a value the form derives, not the user
 *   hint         helper text shown while the field has no error
 *   className    grid placement, e.g. a full-width row
 */
export const TextField = ({
  name,
  label,
  placeholder,
  type = 'text',
  rules,
  required = false,
  disabled = false,
  hint,
  className,
}) => (
  <Field name={name} required={required} rules={rules}>
    {({ id, name: inputName, value, onChange, onBlur, status, message, required: isRequired }) => (
      <TextInput
        className={className}
        id={id}
        name={inputName}
        type={type}
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        status={status}
        message={message ?? hint}
        required={isRequired}
        disabled={disabled}
      />
    )}
  </Field>
);
